import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor() { }

  mensajeRapido(mensaje:string,title:string,icono:any){
    Swal.fire({
      title:title,
      html: mensaje,
      timer: 3500,
      icon: icono,
      showConfirmButton: false,
      timerProgressBar: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    })
  }

  MensajeConfirm(mensaje:string,title:string, cancel:boolean, confirmText:string,denyText:string,icono:any):any{
    return Swal.fire({
      title: title,
      text: mensaje,
      icon:icono,
      showCancelButton: cancel,
      cancelButtonText: denyText,
      confirmButtonColor: '#212529',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmText
    })
      
  }
    
  
}
